import { MODE } from "../../config";
import { axios } from "../../utils/axios";

export const handleIngresoApp = async () => {
  if (MODE === "production") {
    const result = axios().post("registrar_ingreso_busqueda_por_dominio", {
      app_name: "foto-multa",
    });
  }
};

export const stringMensajePara = (valor, datosSobre) => {
  if (!valor && !datosSobre) {
    return;
  }
  const datosSobreStr =
    datosSobre === "dominio"
      ? "dominio"
      : datosSobre === "documento" && valor.length === 11
        ? "CUIT"
        : "documento";

  let mensaje = `para el ${datosSobreStr} ${valor.toUpperCase()}`;
  return mensaje;
};
